module.exports = __webpack_public_path__ + "static/media/iconAbsence.26f35a2f.svg";